import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '../common/vuex/store'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/pl'
import VTooltip from 'v-tooltip'
import { APP_CONFIG } from '@/doladujtutaj/const/config.const'
import { APP_ENV } from '@/common/const/env.const'
import { TOPUP_CONFIG } from './const/topup.const'
import filterPln from '../common/filters/pln.filter'

Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(ElementUI, { locale })
Vue.use(VTooltip)
Vue.filter('pln', filterPln)

Vue.prototype.$VUE_APP_CONFIG = APP_CONFIG[process.env.NODE_ENV]
Vue.prototype.$VUE_TOPUP_CONFIG = TOPUP_CONFIG

if (process.env.NODE_ENV === APP_ENV.development && process.env.VUE_APP_USE_MOCK === 'true') {
  const { worker } = require('../mock/browser')
  worker.start()
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
